export default __webpack_public_path__ + "static/media/Insent-icon.4fb5dd14.svg";